module.exports = __webpack_public_path__ + "img/11.9cd18bc9.jpg";